<template>
  <div class="main-page wap">
    <Header></Header>
    <Banner></Banner>
    <Carousel></Carousel>
    <div class="m-wap-page top0 page-bottom">
      <Column></Column>
      <List></List>
    </div>
  </div>
</template>
<script>
//import Vue from "vue";
import Header from "../../components/Header";
import Column from "../../components/Wap/Column.vue";
//import Banner from "../../components/Banner.vue";
import List from "../../components/Wap/List.vue";
import Carousel from "../../components/Wap/Carousel.vue";
import { $subscriber } from "fire-wind-water";

import { articleCategoryId } from "../../common/sbase";
import Banner from "../../components/Banner.vue";
//  import $ from "jquery";

export default {
  name: "MoreColumn",
  data() {
    return {
      page: {
        backgroundColor: {
          value: ""
        }
      }
    };
  },
  methods: {
    getCategory() {
      articleCategoryId;
    }
  },
  created() {
    $subscriber.subscribe("config-loaded", res => {
      this.page = res.page;
      // $('body').css('background-color',this.page.backgroundColor.value)
      //      window.$sk.loading.hide();
    });
  },
  components: {
    Banner,
    Header,
    Column,
    //    Banner,
    List,
    Carousel
  }
};
</script>
